import React from 'react';
import Spinner from '@/components/common/Spinner';
import { ChildrenMap, SearchResult } from './standardsTreeUtils';
import StandardsTree from './StandardsTree';
import { StandardNode } from './types';

interface StandardsBrowserContentProps {
  childrenMap: ChildrenMap;
  correlationCountMap: Map<number, number>;
  expandedGrades: Set<string>;
  expandedNodes: Set<number>;
  gradeFilter: string;
  isLoading: boolean;
  searchQuery: string;
  searchResult: SearchResult;
  showCorrelationCounts: boolean;
  standards: StandardNode[];
  stateName: string | null;
  onClearSearch?: () => void;
  onToggleGrade: (grade: string) => void;
  onToggleNode: (id: number) => void;
}

const StandardsBrowserContent = ({
  childrenMap,
  correlationCountMap,
  expandedGrades,
  expandedNodes,
  gradeFilter,
  isLoading,
  searchQuery,
  searchResult,
  showCorrelationCounts,
  standards,
  stateName,
  onClearSearch,
  onToggleGrade,
  onToggleNode,
}: StandardsBrowserContentProps) => {
  if (!stateName) return <span className="tw-font-bold">Select a State to see standards.</span>;

  if (isLoading) {
    return (
      <div className="tw-flex tw-flex-col tw-items-center tw-gap-2">
        <Spinner />
        <span>Loading&hellip;</span>
      </div>
    );
  }

  if (standards.length === 0) return <>{`No standards data available for ${stateName}.`}</>;

  return (
    <StandardsTree
      childrenMap={childrenMap}
      correlationCountMap={correlationCountMap}
      expandedGrades={expandedGrades}
      expandedNodes={expandedNodes}
      gradeFilter={gradeFilter}
      searchQuery={searchQuery}
      searchResult={searchResult}
      showCorrelationCounts={showCorrelationCounts}
      standards={standards}
      onClearSearch={onClearSearch}
      onToggleGrade={onToggleGrade}
      onToggleNode={onToggleNode}
    />
  );
};

export default StandardsBrowserContent;
